import { useEffect } from 'react';

const DEFAULT_TITLE = 'Mims Family Painting | Painting & Finishes';

/**
 * Sets the document title and og:title meta tag for the current page.
 * Pass a page name (e.g. "About") to get "About | Mims Family Painting".
 * Pass nothing or empty string for the default home title.
 */
export function useDocumentTitle(title?: string) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} | Mims Family Painting`
      : DEFAULT_TITLE;

    document.title = fullTitle;

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', fullTitle);
    }
  }, [title]);
}
